angular.module('app.player.analysisController', [])
.controller('app.player.analysisController', [
  '$scope',
  function ($scope) {
    "use strict";

    // TODO: these should come from a service
    // GAME, LOCATION and PLAYER lists should prob be queried from api
    // Other arrays are non-changing

    let analysisMenuCategoriesGame = [{
      val: 'game_all',
      txt: 'all'
    }];

    let analysisMenuCategoriesEvent = [{
      val: 'evt_all',
      txt: 'all'
    }, {
      val: 'evt_uncategorized',
      txt: 'uncategorized'
    }, {
      val: 'evt_goal_for',
      txt: 'goal for'
    }, {
      val: 'evt_goal_against',
      txt: 'goal against'
    }, {
      val: 'evt_power_play',
      txt: 'power play'
    }, {
      val: 'evt_penalty_kill',
      txt: 'penalty kill'
    }, {
      val: 'evt_penalty_shot',
      txt: 'penalty shot'
    }, {
      val: 'evt_penalty_shot_against',
      txt: 'penalty shot against'
    }, {
      val: 'evt_faceoff',
      txt: 'faceoff'
    }, {
      val: 'evt_forecheck',
      txt: 'forecheck'
    }, {
      val: 'evt_neutral_zone',
      txt: 'neutral zone'
    }, {
      val: 'evt_defensive_zone',
      txt: 'defensive zone'
    }, {
      val: 'evt_hit',
      txt: 'hit'
    }, {
      val: 'evt_hit_against',
      txt: 'hit against'
    }, {
      val: 'evt_fight',
      txt: 'fight'
    }, {
      val: 'evt_breakout',
      txt: 'breakout'
    }, {
      val: 'evt_zone_entry',
      txt: 'zone entry'
    }, {
      val: 'evt_short_highlight',
      txt: 'short highlight'
    }, {
      val: 'evt_long_highlight',
      txt: 'long highlight'
    }];

    let analysisMenuCategoriesPeriod = [{
      val: 'per_all',
      txt: 'all'
    }, {
      val: 'per_1',
      txt: '1'
    }, {
      val: 'per_2',
      txt: '2'
    }, {
      val: 'per_3',
      txt: '3'
    }];

    let analysisMenuCategoriesPlayer = [{
      val: 'player_all',
      txt: 'all'
    }];

    $scope.analysisMenuSelection = {
      val: 'event'
    };

    $scope.analysisMenuCategoriesShow = analysisMenuCategoriesEvent;

    $scope.analysisMenuSelectionChange = function () {

      if ($scope.analysisMenuSelection.val === 'game') {
        $scope.analysisMenuCategoriesShow = analysisMenuCategoriesGame;

      } else if ($scope.analysisMenuSelection.val === 'event') {
        $scope.analysisMenuCategoriesShow = analysisMenuCategoriesEvent;

      } else if ($scope.analysisMenuSelection.val === 'period') {
        $scope.analysisMenuCategoriesShow = analysisMenuCategoriesPeriod;

      } else if ($scope.analysisMenuSelection.val === 'player') {
        $scope.analysisMenuCategoriesShow = analysisMenuCategoriesPlayer

      } else if ($scope.analysisMenuSelection.val === 'location') {

      }
    };

    $scope.analysisCategoryClicked = function (cat) {
    };
  }
]);


// WEBPACK FOOTER //
// ./app.v2/components/player/analysis/analysisController.js